import BuildingProgram from './BuildingProgram';

export default BuildingProgram;